import React from "react";
import { Field } from "formik";
import { isMobile } from "react-device-detect";
import "./checkBoxCourse.css";

export default function CheckBoxCourse({ value }) {
  return (
    <>
      <div className={isMobile ? "courseBoxStyleMobile" : "courseBoxStyle"}>
        <label style={{ display: "flex", alignItems: "center" }}>
          <Field
            type="checkbox"
            name="courses"
            value={value}
            className={
              isMobile
                ? " course-check-box-style course-check-box-style-mobile"
                : "course-check-box-style"
            }
          />
          <div className={isMobile ? " courseText courseTextMobile" : "courseText"}>{value}</div>
        </label>
      </div>
    </>
  );
}
